import React, { Component } from "react";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";
import { TextShow } from "../Essentials/TextShow";
import NotificationDescription from "../Notifications/NotificationDescription";

class ForStudentsDescription extends Component {
  render() {
    return (
      <div>
        {this.props.type == "institutional-internship-policy" ? (
          <TextShow
            title="Institutional Internship Policy"
            type="INSTITUTIONAL_INTERNSHIP_POLICY"
          />
        ) : null}

        {this.props.type == "institutional-apprenticeship-policy" ? (
          <TextShow
            title="Institutional Apprenticeship Policy"
            type="INSTITUTIONAL_APPRENTICESHIP_POLICY"
          />
        ) : null}

        {this.props.type == "rules-and-guidelines" ? (
          <TextShow title="Rules & Guidelines" type="RULES_AND_GUIDELINES" />
        ) : null}

        {this.props.type == "apply-for-noc" ? (
          <div>
            <BreadCrumbOwn title="Apply for NoC" />
            <NotificationDescription title="Apply for NoC" code="APPLY_FOR_NOC" />
          </div>
        ) : null}

        {this.props.type == "apply-for-internship" ? (
          <div>
            <BreadCrumbOwn title="Apply for Internship" />
            <NotificationDescription
              title="Apply for Internship"
              code="APPLY_FOR_INTERNSHIP"
            />
          </div>
        ) : null}

        {this.props.type == "apply-for-apprenticeships" ? (
          <div>
            <BreadCrumbOwn title="Apply for Apprenticeships" />
            <NotificationDescription
              title="Apply for Apprenticeships"
              code="APPLY_FOR_APPRENTICESHIPS"
            />
          </div>
        ) : null}

        {this.props.type == "documents-and-resources" ? (
          <div>
            <BreadCrumbOwn title="Documents and Resources" />
            <NotificationDescription
              title="Documents and Resources"
              code="DOCUMENTS_AND_RESOURCES"
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default ForStudentsDescription;
